import MicroModal from 'micromodal';
import { Component } from '@verndale/core';
import YouTubePlayer from 'youtube-player';

class VideoModal extends Component {
  setupDefaults() {
    this.dom = {
      player: this.el.querySelector('.video-modal__player')
    };

    this.modalId = this.el.id;
    this.videoId = this.dom.player.dataset.videoId;
    this.createVideoPlayer();
  }

  addListeners() {
    this.player.on('ready', ::this.onPlayerReady)
  }

  show() {
    MicroModal.show(this.modalId, {
      awaitCloseAnimation: true,
      onShow: ::this.playVideo,
      onClose: ::this.pauseVideo
    });
  }

  createVideoPlayer() {
    this.player = YouTubePlayer(this.dom.player, {
      videoId: this.videoId,
      playerVars: {
        controls: 1,
        enablejsapi: 1,
        fs: 1,
        modestbranding: 0,
        autoplay: 0,
        playsinline: 0,
        rel: 0,
        loop: 1
      }
    });
  }

  onPlayerReady() {
    if (this.props.onPlayerReady) {
      this.props.onPlayerReady();
    }
  }

  playVideo() {
    if (this.player) {
      this.player.playVideo();
    }
  }

  pauseVideo() {
    if (this.player) {
      this.player.pauseVideo();
    }
  }
}

export default VideoModal;
